import { GeoModal } from '@carvana/merch-geolocation';
import { useContext, useEffect, useMemo, useRef } from 'react';
import Modal from '@/Modal';
import { DELIVERY_CONTEXT } from '~/constants/endpoints';
import ModalContext from '~/contexts/ModalContext';
import UserContext from '~/contexts/UserContext';
import { Location } from '~/contracts';
import getClientSideGeolocation from '~/services/getClientSideGeolocation';

const fetchDelivery = (zip: string) =>
  fetch(`${DELIVERY_CONTEXT}?zip5=${zip}`).then(res => res.json());

// Return properties required by package
function useGeolocationConfig() {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const { setUserLocation, userLocation } = useContext(UserContext);
  const geolocation = useRef<Partial<Location>>(userLocation);

  useEffect(() => {
    geolocation.current = userLocation;
  }, [userLocation]);

  return useMemo(
    () => ({
      fetchDelivery,
      geoApi: getClientSideGeolocation(),
      onCloseHandler() {
        setGeolocationModalOpen(false);
      },
      onUserLocationChange({ location: newLocation }) {
        if (geolocation.current.zip === newLocation.zip || !newLocation.zip) {
          return;
        }

        setUserLocation(newLocation);
      }
    }),
    [setGeolocationModalOpen, setUserLocation]
  );
}

export default function GeolocationModal() {
  const { isGeolocationModalOpen, setGeolocationModalOpen } =
    useContext(ModalContext);
  const config = useGeolocationConfig();

  return (
    <GeoModal config={config}>
      {({ content }) => (
        <Modal
          open={isGeolocationModalOpen}
          onToggle={() => {
            setGeolocationModalOpen(false);
          }}
          headerText="Update Your Location"
        >
          {content}
        </Modal>
      )}
    </GeoModal>
  );
}
